import { render, staticRenderFns } from "./AppointmentOverview.vue?vue&type=template&id=c5b6794a&"
import script from "./AppointmentOverview.controller.js?vue&type=script&lang=js&"
export * from "./AppointmentOverview.controller.js?vue&type=script&lang=js&"
import style0 from "./AppointmentOverview.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports